export const formatPrice = (value = 0) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return '0.00';
    return numericValue.toFixed(2);
};
